import { render, staticRenderFns } from "./AutomakersSuppliers.vue?vue&type=template&id=650c4642&scoped=true"
import script from "./AutomakersSuppliers.vue?vue&type=script&lang=js"
export * from "./AutomakersSuppliers.vue?vue&type=script&lang=js"
import style0 from "./AutomakersSuppliers.vue?vue&type=style&index=0&id=650c4642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c4642",
  null
  
)

export default component.exports